import { canUseRooms } from "../session/secure";

export { canUseRooms };

/** Explains what's off when the app is opened over plain http on another host. */
export function InsecureBanner() {
  if (canUseRooms()) return null;
  return (
    <div className="banner banner-warning" role="alert">
      <span>
        This page isn't served over https (or from localhost), so the browser turns off what rooms
        need. You can edit and run code alone; to share, open it over https.
      </span>
    </div>
  );
}
